import {createRouter, createWebHistory, RouteParams} from 'vue-router';
import {AppRouteNames} from '@/types/router-name';
import {useRoute} from '@/composables/useRoute';
import {store} from '@/store';
import database, {dbName} from '@/database';

const {routes} = useRoute();

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

let newVal: any = {};
const installDatabase = (account_id: any) => {
    /*
      This function create local database (use IndexedDB) to store recently emojis, recently stickers
    */
    newVal[account_id] = [];
    /* Create emoji database */
    database.getItem(dbName.emoji, (err, value: any) => {
        if (!value) {
            database.setItem(dbName.emoji, newVal);
        } else {
            if (!value[account_id]) {
                newVal = value;
                newVal[account_id] = [];
                database.setItem(dbName.emoji, newVal);
            }
        }
    });
    /* Create list emoji database */
    database.getItem(dbName.listEmoji, (err, value: any) => {
        if (!value) {
            database.setItem(dbName.listEmoji, newVal);
        } else {
            if (!value[account_id]) {
                newVal = value;
                newVal[account_id] = [];
                database.setItem(dbName.listEmoji, newVal);
            }
        }
    });
    /* Create emoji database in Setting Chat widget */
    database.getItem(dbName.widgetSetingEmoji, (err, value: any) => {
        if (!value) {
            database.setItem(dbName.widgetSetingEmoji, newVal);
        } else {
            if (!value[account_id]) {
                newVal = value;
                newVal[account_id] = [];
                database.setItem(dbName.widgetSetingEmoji, newVal);
            }
        }
    });
    /* Create list count emoji database in Setting Chat widget */
    database.getItem(dbName.widgetSetingEmojiCount, (err, value: any) => {
        if (!value) {
            database.setItem(dbName.widgetSetingEmojiCount, newVal);
        } else {
            if (!value[account_id]) {
                newVal = value;
                newVal[account_id] = [];
                database.setItem(dbName.widgetSetingEmojiCount, newVal);
            }
        }
    });
};

router.beforeEach(async (to, from, next) => {
    next();
});

router.beforeEach(async (to, from, next) => {
    if (to.meta.middleware) {
        const middleware: any = to.meta.middleware;
        const context = {next, from, to, router, store};
        let preventNext = false;
        for (let i = 0; i < middleware.length; i++) {
            const result = await middleware[i](context);
            if (!result) {
                preventNext = true;
                break;
            }
        }
        if (preventNext) {
            return;
        }
    }

    next();
});

export function routerPush(name: AppRouteNames, params?: RouteParams): ReturnType<typeof router.push> {
    if (params !== undefined) {
        return router.push({
            name,
            params,
        });
    } else {
        return router.push({name});
    }
}

export {router};
